var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline-block", "text-indent": "0" } },
    [
      _c("input", {
        staticStyle: { display: "none" },
        attrs: { id: _vm.buttonId, type: "file", accept: _vm.acceptType },
        on: { input: _vm.changeAction }
      }),
      _vm._v(" "),
      _c(
        "Button",
        {
          class: _vm.buttonClass,
          attrs: {
            icon: _vm.buttonIcon,
            size: _vm.buttonSize,
            type: _vm.buttonType
          },
          on: { click: _vm.triggerFileSelecter }
        },
        [_vm._v(" " + _vm._s(_vm._f("t")(_vm.buttonName)) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93a09bcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93a09bcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload_file.vue
// module id = null
// module chunks = 